import { Emitter } from "@ciaopeople/cp-shatsu/Queues";
import { GoogleCredentialResponse } from "../OneTapDelegate.js";
import { debug } from "../../LoginDbg.js";

export class GSILoader {

    private gsiEmitter: Emitter<GoogleCredentialResponse>;
    private gsiPromise: Promise<any> = null;

    constructor(public readonly client_id: string,
        public readonly state_cookie_domain: string) {

        this.gsiEmitter = new Emitter<GoogleCredentialResponse>(600 * 1000);
    }  

    public gsiInit(): Promise<any> {

        if(this.gsiPromise == null) {
    
            this.gsiPromise = new Promise((mainResolve) => {
                ((d, s, id) => {
                    let js: any = null;
                    const gjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) {
                        return;
                    }
                    js = d.createElement(s); js.id = id;
                    js.src = 'https://accounts.google.com/gsi/client';
                    gjs.parentNode.insertBefore(js, gjs);
                    debug.write("Running OneTap login");
                    window['onGoogleLibraryLoad'] = () => {
                        debug.write("onGoogleLibraryLoad GSI");
                        window['google'].accounts.id.initialize({
                            client_id: this.client_id,
                            auto_select: true,
                            state_cookie_domain: this.state_cookie_domain,
                            use_fedcm_for_prompt: true,
                            use_fedcm_for_button: false, //try using true
                            cancel_on_tap_outside: false,
                            callback: (response) => {
                                debug.write("GSI Response",response);
                                this.gsiEmitter.emit(response);
                            }
                        });
                        mainResolve(window['google'].accounts);
                    };
    
                })(document, 'script', 'google-jssdk-sdi');
            });
        }
        return this.gsiPromise;
    }


    public getNextCredentialResponse(): Promise<GoogleCredentialResponse> {
        return this.gsiEmitter.lastIfNotStaleOrNext();
    }

    public cancelOneTapPrompt() {
        if (this.gsiPromise) {
            this.gsiPromise.then(
                () => {
                    window['google'].accounts.id.cancel();
                }
            );
        }
    }
}